import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { TrustDetail } from '../../Models/Domains/Account/TrustDetail';

declare var IS_RUNNING_IN_APP_POOL;

export class TrustDetailsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyIds: Array<string>): Promise<Array<TrustDetail>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/TrustDetails/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyIds: hierarchyIds }

    return AjaxWrapper.get<Array<TrustDetail>, any>(url, data);
  }
}

